/*
 * @Author: vinc
 * @LastEditTime: 2020-11-05 14:59:15
 */
import Vue from 'vue'
import Vuex from 'vuex'

import axios from '@/plugins/axios'
import router from '../router'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    data: {},
    websiteTel: '400-660-3099',
    userInfo: null,
    mallTypes: [],
    formTitle: '',
    token: sessionStorage.getItem('token') ? JSON.parse(sessionStorage.getItem('token')) : null,
    tokenObj: null,
    tel: '',
    addressList: {}
  },
  mutations: {
    SET_DATA(state, payload) {
      state.data = {
        ...payload
      }
    },
    SET_TEL(state, payload) {
      state.tel = payload
    },
    SET_TITLE(state, payload) {
      state.formTitle = payload
    },
    SET_TOKEN(state, payload) {
      state.tokenObj = payload;
    },
    REMOVE_TOKEN(state, payload) {
      state.tokenObj = null;
      state.userInfo = null;
      sessionStorage.removeItem('tokenObj')
      axios.defaults.headers.common['authorization'] = null;
    },
    SET_USERINFO(state, payload) {
      state.userInfo = {
        ...payload
      };
    },
    SET_MALLTYPE(state, payload) {
      state.mallTypes = payload
    },
    SET_ADDRESSLIST(state, payload) {
      state.addressList = { ...payload }
    },
  },
  actions: {
    changeRouter({ commit }, params) {
      router
        .push(params)
        .catch(err => {
          console.log("router err");
        });
    },
    async setTitle({
      commit
    }, params) {
      commit('SET_TITLE', params)
    },
    async getInfo({
      commit
    }, params) {
      const res = await axios.get(`${process.env.API.api}/user/info`, params);
      if (!parseInt(res.data.code)) {
        commit('SET_INFO', res.data.data);
        localStorage.setItem('userInfo', JSON.stringify(res.data.data));
      }
    },
    async saveData({
      commit
    }, params) {
      const res = await axios.post(`http://wap-novel.com/api/login`, params)
      if (res) {
        commit('SET_DATA', res.data)
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js